// Standard library imports
import React, { useState, useEffect } from 'react';

// External library imports
import { flatten } from 'flat';
import _ from 'lodash';
// Internal module imports
import Typography from '../../../../components/Typography/Typography';
import { momentTimeFormater, timeOnlyWithms } from '../../../../utils/dateHelper';
import { useLoader } from '../../../../hooks';
import { activationProfileService } from '../../../../services/ActivationProfileService';
import { DownloadAsExcel } from '../../../../utils/downloadAsExcel';
import DownloadButton from '../../../../components/Buttons/DownloadButton';
import { usToEuCurrencyFormat } from '../../../../utils/currencyHelper';

// External library imports
import { Menu, MenuItem } from '@szhsin/react-menu';

// Css imports
import activationClasses from '../ActivationProfiler.module.css';
import EChart from '../../../../components/Echarts/Echarts';

const DataLogModel = ({ setOpen, dataLogModal, market }) => {
    const [startLoader, stopLoader] = useLoader();
    const [frequencyData, setFrequencyData] = useState([]);
    const [powerData, setPowerData] = useState([]);
    const [setPointData, setSetPointData] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        if (dataLogModal.id && market) {
            activationProfileService.getDataLog(dataLogModal.id, { type: market }, startLoader, handledataLogSuccess, handleError, stopLoader);
        }
    };

    const handledataLogSuccess = ({ data }) => {
        setPowerData(data.data.powerGraph);
        setFrequencyData(data.data.frequencyGraph);
        setSetPointData(data.data.setPointGraph);
    };

    const getDownloadData = (prefillData) => {
        activationProfileService.getDataLog(dataLogModal.id, { type: market, prefillData: prefillData }, startLoader, handleDownloadDataSuccess, handleError, stopLoader);
    };

    const handleDownloadDataSuccess = ({ data }) => {
        let columnIndex = 0;
        let columnLength = 0;
        const flattenedData = data.data.downloadable
            .map((item) => flatten(item, { delimiter: '_' }))
            .map((item, index) => {
                const timestampCET = item.timestampCET;
                delete item.timestampCET;
                const objectLength = Object.keys(item).length;
                if (objectLength > columnLength) {
                    columnLength = objectLength;
                    columnIndex = index;
                }
                return {
                    timestampCET,
                    ...item,
                };
            });

        const columnNames = ['TIMESTAMP (CET)'];
        for (let key in flattenedData[columnIndex]) {
            if (key !== 'timestampCET') {
                columnNames.push(key.toUpperCase());
            }
        }
        DownloadAsExcel(flattenedData, `${dataLogModal.meta.groupName} DataLog - ${dataLogModal.meta.startTime}`, columnNames, columnIndex);
    };

    const handleError = (err) => {
        console.log(err);
    };
    const formatYAxisValue = (value) => {
        return usToEuCurrencyFormat(value, 3);
    };
    return (
        <div className={activationClasses.DataLogModalContainter}>
            <Typography content={'Data Log'} />
            <div className={activationClasses.ButtonContainer2}>
                <Menu
                    menuButton={
                        <div>
                            <DownloadButton size={'medium'} />
                        </div>
                    }
                    direction={'bottom'}
                    arrow={true}
                    menuClassName={activationClasses.Menu}
                >
                    <MenuItem onClick={() => getDownloadData(false)} className={activationClasses.MenuOptions}>
                        <div>Raw Download</div>
                    </MenuItem>
                    <MenuItem onClick={() => getDownloadData(true)} className={activationClasses.MenuOptions}>
                        <div>Advanced Download</div>
                    </MenuItem>
                </Menu>
            </div>
            <div>
                <div style={{ height: '35vh' }}>
                    <EChart
                        title={'Frequency (Hz)'}
                        type="line"
                        series={frequencyData}
                        xFormatter={(v) => timeOnlyWithms(momentTimeFormater(v))}
                        yFormatter={formatYAxisValue}
                        group={'signalLog'}
                        zoomOnMouseWheel={false}
                        yAxisProps={_.get(frequencyData, [0, 'data'], []).length ? { min: 'dataMin', max: 'dataMax' } : {}}
                        yTooltipSuffix={['Hz']}
                    />
                </div>
                <div style={{ height: '35vh' }}>
                    <EChart
                        title={'Set Point'}
                        type="line"
                        series={setPointData}
                        xFormatter={(v) => timeOnlyWithms(momentTimeFormater(v))}
                        yFormatter={formatYAxisValue}
                        group={'signalLog'}
                        zoomOnMouseWheel={false}
                        yTooltipSuffix={['%']}
                    />
                </div>
                <div style={{ height: '35vh' }}>
                    <EChart
                        title="Power (kW)"
                        type="line"
                        series={powerData}
                        xFormatter={(v) => timeOnlyWithms(momentTimeFormater(v))}
                        yFormatter={formatYAxisValue}
                        group={'signalLog'}
                        zoomOnMouseWheel={false}
                        yTooltipSuffix={['kW']}
                    />
                </div>
            </div>
            <div className={activationClasses.ButtonContainer}>
                <div className="btn-secondary" onClick={setOpen}>
                    Close
                </div>
            </div>
        </div>
    );
};

export default DataLogModel;
